<template>
	<b-form-group
		:invalid-feedback="error"
		:label="$t('Subtract')"
		:readonly="readonly"
		:state="error ? false : null"
		:label-for="'subtraction_mode'+uuid"
	>
		<b-form-select
			:id="'subtraction_mode'+uuid"
			:options="options"
			:state="error ? false : null"
			:value="value"
			name="subtraction_mode"
			@input="$emit('input', $event)"
		/>
	</b-form-group>
</template>

<script>
import {SUBTRACTION_MODES} from "@/constants";

export default {
	name: "SubtractionModeSelect",
	props: {
		value: {
			type: Number,
			default: 0,
		},
		error: {
			type: Boolean,
			default: null
		},
		readonly: {
			type: Boolean,
			default: false
		},
		override:{
			type:Boolean,
			default:false
		},
		defaultElementMode:{
			type:Number,
			default:null
		}
	},
	computed: {
		options() {
			return Object.keys(SUBTRACTION_MODES).map(mode => {
				let text = this.override ? this.$t(`subtraction_modes.override.${SUBTRACTION_MODES[mode]}`) : this.$t(`subtraction_modes.${SUBTRACTION_MODES[mode]}`)
				if (this.defaultElementMode !== null){
					text = text + (this.defaultElementMode === SUBTRACTION_MODES[mode] ? this.$t('Default'):'')
				}
				return {
					value: SUBTRACTION_MODES[mode],
					html: text ,
				}
			})
		}

	}
}
</script>